import { useEffect, useState } from 'react';
import { stopMediaStream } from '../utils/media';

/**
 * Opens a camera stream for the selected device.
 */
export function useCameraStream(deviceId: string): MediaStream | null {
  const [stream, setStream] = useState<MediaStream | null>(null);

  useEffect(() => {
    let activeStream: MediaStream | null = null;
    let isCancelled = false;

    const setup = async () => {
      try {
        const nextStream = await navigator.mediaDevices.getUserMedia({
          video: deviceId ? { deviceId: { exact: deviceId } } : true,
          audio: false,
        });

        if (isCancelled) {
          stopMediaStream(nextStream);
          return;
        }

        activeStream = nextStream;
        setStream(nextStream);
      } catch {
        setStream(null);
      }
    };

    void setup();

    return () => {
      isCancelled = true;
      if (activeStream) {
        stopMediaStream(activeStream);
      }
    };
  }, [deviceId]);

  return stream;
}
